<template>
    <confirmation-popup
            ref="popup"
            v-bind:title="resource('DmVisualizer_ScenarioActivationConfirmationPopup_Title')"
            v-bind:texts="{ header: scenario.batchActivationTextHeader, body: scenario.batchActivationText }"
    >
        <button
                class="btn btn-primary"
                @click="$emit('confirm')"
        >
            {{resource('DmVisualizer_ScenarioActivationConfirmationPopup_ConfirmationButtonText')}}
        </button>
    </confirmation-popup>
</template>

<script>
    import resourceMixin from '../../../../Util/Mixins/resources'

    import ConfirmationPopup from "./../ConfirmationPopup.vue";

    export default {
        name: "scenario-activation-confirmation-popup",
        mixins: [resourceMixin],
        components: {ConfirmationPopup},
        methods: {
            show(){
                this.$refs.popup.show();
            },
            hide(){
                this.$refs.popup.hide();
            }
        },
        props: {
            scenario: {
                type: Object,
                required: true,
                default: () => ({
                    batchActivationTextHeader: '',
                    batchActivationText: ''
                })
            },
        }
    }
</script>
